export const GLOBAL = {
    // URL PRODUCCIÓN
     url: 'https://soporte.senagua.gob.ec/mesaayuda/mesaayudabackend/ws'

    // URL PRUEBAS
    // url: 'http://10.0.1.198/mesaayuda/mesaayudabackend/ws'
};



// WEBPACK FOOTER //
// ./src/app/services/global.ts